var dataUriRegex = new RegExp('<img[^>]*\\s+src=["\']data:image\\/[^<]+;base64,[a-zA-Z0-9+\\/=&#;]+["\'][^>]*>', 'gi');
export default function getDataUriCount(html) {
    var result = 0;
    if (html) {
        var match = html.match(dataUriRegex);
        result = match ? match.length : 0;
    }
    return result;
}
//# sourceMappingURL=getDataUriCount.js.map